import React from 'react'
import { FormattedNumber } from 'react-intl'

import { IndicatorCardContainer } from './IndicatorCardContainer'
import { IndicatorCardTitle } from './IndicatorCardTitle'
import { IndicatorCardContent } from './IndicatorCardContent'
import { ComparableValue } from './ComparableValue'
import { IndicatorComparisonContainer } from './IndicatorComparisonContainer'
import { IndicatorValue } from './IndicatorValue'
import { PercentageDifference } from './PercentageDifference'

export type IndicatorComparableCardProps = {
  title: string
  value: number
  comparisonValue?: number
  style?: 'currency' | 'decimal'
  currency?: string
}

export const IndicatorComparableCard = ({
  title,
  value,
  comparisonValue,
  style = 'decimal',
  currency,
}: IndicatorComparableCardProps) => {
  const diffComparison = comparisonValue
    ? (value * 100) / comparisonValue - 100
    : undefined

  return (
    <IndicatorCardContainer>
      <IndicatorCardTitle>{title}</IndicatorCardTitle>
      <IndicatorCardContent>
        {comparisonValue && (
          <ComparableValue>
            <FormattedNumber
              style={style}
              currency={currency}
              value={comparisonValue}
            />
          </ComparableValue>
        )}
        <IndicatorComparisonContainer>
          <IndicatorValue>
            <FormattedNumber
              style={style}
              currency={currency}
              minimumFractionDigits={style === 'currency' ? 2 : undefined}
              value={value}
            />
          </IndicatorValue>
          {diffComparison && <PercentageDifference value={diffComparison} />}
        </IndicatorComparisonContainer>
      </IndicatorCardContent>
    </IndicatorCardContainer>
  )
}
